export default {
  methods: {
    asset(path) {
      return process.env.VUE_APP_URL + path;
    },
  },
}
